import {createReducer} from "@reduxjs/toolkit";
import {
    addColorFilterAttribute,
    removeColorFilterAttribute,
    updateColorFilterDecayValues,
    updateColorFilterParityValues,
    updateColorFilterValues,
    clearAllFilters
} from "../actions/ColorFilterAction";


function isDiscreteAttribute(attribute) {
    return attribute === 'decay mode' || attribute === 'parity';
}

export const colorFilterReducer = createReducer([],
    (builder) => {
        builder
            .addCase(addColorFilterAttribute, (state, action) => {
                let attribute = action.payload.attribute.value;
                let label = action.payload.attribute.label;
                let type = isDiscreteAttribute(attribute) ? 'discrete' : 'continuous';

                return [...state, {attribute: attribute, label: label, type: type, minVal: '', maxVal: '', options: []}];
            })
            .addCase(removeColorFilterAttribute, (state, action) => {
                return state.filter(attribute => attribute.attribute !== action.payload.attribute);
            })
            .addCase(updateColorFilterParityValues, (state, {payload}) => {
                let parityAttribute = state.find(attribute => attribute.attribute === 'parity');
                parityAttribute.options = payload;
            })
            .addCase(updateColorFilterDecayValues, (state, {payload}) => {
                let decayAttribute = state.find(attribute => attribute.attribute === 'decay mode');
                decayAttribute.options = payload;
            })
            .addCase(updateColorFilterValues, (state, {payload}) => {
                let attribute = state.find(attribute => attribute.attribute === payload.attribute);
                attribute[payload.param] = payload.val;
            })
            .addCase(clearAllFilters, (state, action) => {
                return [];
            });
    }
);
